<router-outlet></router-outlet>

<!-- Concierge chat overlay disabled.
<app-chat-overlay
  [open]="chatOpen"
  [busy]="sending"
  [isTyping]="typing"
  [messages]="msgs"
  [title]="'Signature Tours'"
  [subtitle]="'Concierge · Online'"
  [avatar]="'/assets/logo_old.webp'"
  (toggle)="toggleChat()"
  (close)="closeChat()"
  (send)="onSend($event)"
  (quickReply)="onSend($event)">
</app-chat-overlay>
-->

<app-whatsapp-btn></app-whatsapp-btn>
<app-scroll-buttons></app-scroll-buttons>

